import { useState } from "react";
import { Avatar, Layout, Menu } from "antd";
import { DownOutlined, UserOutlined, LoginOutlined } from "@ant-design/icons";
import ConfirmationModal from "../../Modal/ConfirmationModal";
import { useNavigate } from "react-router-dom";
const { Header } = Layout;
const HeaderComponent = ({ name }) => {
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  const navigate = useNavigate();
  const showLogoutModal = () => {
    setIsLogoutModalOpen(true);
  };
  const handleLogoutOk = () => {
    setIsLogoutModalOpen(false);
    localStorage.removeItem("token");
    localStorage.clear();
    navigate("");
    window.location.href = "/n146m149";
  };
  const handleLogoutCancel = () => {
    setIsLogoutModalOpen(false);
  };
  return (
    <>
      <Header style={{ background: "#fff", padding: "0px 16px" }}>
        <div className="text-right">
          <Menu mode="horizontal" className="ml-auto flex justify-end">
            <Menu.SubMenu
              key="SubMenu"
              title={
                <>
                  <span className="cursor-pointer inline-block" onClick={(e) => e.preventDefault()}>
                    <Avatar size={40} icon={<UserOutlined />} />
                    <span className="mx-2">{name}</span>
                    <DownOutlined />
                  </span>
                </>
              }
            >
              <Menu.Item onClick={showLogoutModal}>
                <LoginOutlined className="mr-1" /> Logout
              </Menu.Item>
            </Menu.SubMenu>
          </Menu>
        </div>
      </Header>
      <ConfirmationModal
        ConfirmationHeading="Logout"
        ConfirmationParagraph="Are you sure you want to logout?"
        isOpen={isLogoutModalOpen}
        onOk={handleLogoutOk}
        onCancel={handleLogoutCancel}
      />
    </>
  );
};
export default HeaderComponent;
